<template>
  <div class="dialog-wrap">
    <el-dialog title="部门管理"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form :model="dataForm"
               ref="dataForm"
               :rules="rules"
               label-position="right"
               label-width="110px">
        <el-form-item label="部门名称"
                      prop="name">
          <el-input v-model="dataForm.name"></el-input>
        </el-form-item>
        <el-form-item label="部门负责人">
          <el-input v-model="dataForm.director"></el-input>
        </el-form-item>
        <el-form-item label="部门工作职责">
          <el-input type="textarea"
                    v-model="dataForm.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptEdit } from '@/api/admin'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: this.content || {},
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        director: [
          { required: true, message: '请输入部门负责人', trigger: 'blur' },
        ],
        description: [
          { required: true, message: '请输入部门工作职责', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.dataForm = val
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            director: this.dataForm.director,
            description: this.dataForm.description,
          }
          deptEdit(query)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .dataForm {
    margin-bottom: -18px;
  }
}
</style>
